<div class="hospital-selection-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="logo-container">
      <mat-icon class="logo-icon">local_hospital</mat-icon>
      <h1 class="app-title">Patient Registration</h1>
    </div>
    <p class="subtitle">Select your healthcare facility to continue registration</p>
    <div class="info-banner">
      <mat-icon class="info-icon">info</mat-icon>
      <span>Your account will be reviewed and approved by the hospital administrator</span>
    </div>
  </div>

  <mat-divider class="header-divider"></mat-divider>

  <!-- Search Section -->
  <div class="search-section" *ngIf="!loading && hospitals.length > 0">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search healthcare facilities</mat-label>
      <input 
        matInput 
        [(ngModel)]="searchQuery" 
        (ngModelChange)="applyFilter()"
        placeholder="Search by name, location, or contact..."
        autocomplete="off">
      <mat-icon matPrefix>search</mat-icon>
      <button 
        mat-icon-button 
        matSuffix 
        *ngIf="searchQuery" 
        (click)="clearSearch()"
        aria-label="Clear search">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    
    <div class="results-info">
      <span class="results-count">
        Showing {{ paginatedHospitals.length }} of {{ totalItems }} 
        {{ totalItems === 1 ? 'facility' : 'facilities' }}
      </span>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="loading-text">Loading healthcare facilities...</p>
  </div>

  <!-- Hospital Cards Grid -->
  <div *ngIf="!loading && paginatedHospitals.length > 0" class="hospitals-grid">
    <mat-card 
      *ngFor="let hospital of paginatedHospitals" 
      class="hospital-card"
      [class.selected]="isSelected(hospital)">
      
      <!-- Hospital Header with Icon -->
      <mat-card-header class="hospital-header">
        <div class="hospital-icon-wrapper">
          <mat-icon class="hospital-icon">business</mat-icon>
        </div>
        <div class="hospital-title-section">
          <mat-card-title class="hospital-name">
            {{ hospital.name || 'Unnamed Hospital' }}
          </mat-card-title>
          <mat-card-subtitle class="hospital-type">
            <mat-chip class="type-chip">
              {{ getHospitalType(hospital) }}
            </mat-chip>
          </mat-card-subtitle>
        </div>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="hospital-content">
        <!-- Description -->
        <div *ngIf="hospital.alias && hospital.alias.length > 0" class="hospital-description">
          <mat-icon class="info-icon">info_outline</mat-icon>
          <p>{{ hospital.alias[0] }}</p>
        </div>

        <!-- Address -->
        <div class="hospital-info-row">
          <mat-icon class="info-icon">place</mat-icon>
          <span class="info-text">{{ getHospitalAddress(hospital) }}</span>
        </div>

        <!-- Phone -->
        <div *ngIf="getHospitalPhone(hospital)" class="hospital-info-row">
          <mat-icon class="info-icon">phone</mat-icon>
          <span class="info-text">{{ getHospitalPhone(hospital) }}</span>
        </div>

        <!-- Email -->
        <div *ngIf="getHospitalEmail(hospital)" class="hospital-info-row">
          <mat-icon class="info-icon">email</mat-icon>
          <span class="info-text">{{ getHospitalEmail(hospital) }}</span>
        </div>

        <!-- Active Status Indicator -->
        <div class="status-indicator active">
          <mat-icon class="status-icon">check_circle</mat-icon>
          <span class="status-text">Accepting New Patients</span>
        </div>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Action Button -->
      <mat-card-actions class="hospital-actions">
        <button 
          mat-flat-button 
          color="primary"
          class="select-button"
          (click)="onSelectHospital(hospital)"
          [disabled]="isSelected(hospital)">
          <mat-icon>how_to_reg</mat-icon>
          <span>{{ isSelected(hospital) ? 'Selected' : 'Register Here' }}</span>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <!-- Pagination -->
  <div *ngIf="!loading && filteredHospitals.length > pageSize" class="pagination-container">
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[6, 12, 24, 48]"
      [pageIndex]="pageIndex"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
  </div>

  <!-- Empty State (No Results) -->
  <div *ngIf="!loading && filteredHospitals.length === 0 && hospitals.length > 0" class="empty-state">
    <mat-icon class="empty-icon">search_off</mat-icon>
    <h2>No Matching Facilities Found</h2>
    <p>No healthcare facilities match your search criteria. Try adjusting your search terms.</p>
    <button mat-stroked-button (click)="clearSearch()">
      <mat-icon>clear</mat-icon>
      Clear Search
    </button>
  </div>

  <!-- Empty State (No Hospitals) -->
  <div *ngIf="!loading && hospitals.length === 0" class="empty-state">
    <mat-icon class="empty-icon">domain_disabled</mat-icon>
    <h2>No Healthcare Facilities Available</h2>
    <p>There are currently no healthcare facilities accepting new patient registrations.</p>
    <button mat-stroked-button (click)="loadHospitals()">
      <mat-icon>refresh</mat-icon>
      Retry
    </button>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons" *ngIf="!loading">
    <button mat-stroked-button (click)="onCancel()" class="cancel-button">
      <mat-icon>arrow_back</mat-icon>
      Back to Home
    </button>
  </div>

  <!-- Footer -->
  <div class="footer-section">
    <p class="footer-text">
      © {{ currentYear }} e-Likita Healthcare Platform. All rights reserved.
    </p>
  </div>
</div>